export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const formatDate = (timestamp) => {
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(timestamp));
};

export const sanitizeFilename = (filename) => {
  return filename
    .replace(/[^a-zA-Z0-9.-]/g, '-')
    .replace(/-+/g, '-')
    .toLowerCase();
};

export const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'zip', 'txt'];
export const DANGEROUS_EXTENSIONS = ['exe', 'php', 'js', 'html', 'sh', 'bat', 'cmd'];

export const PREVIEWABLE_TYPES = {
  pdf: ['pdf'],
  image: ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'],
  text: ['txt']
};

export const getFileType = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  if (PREVIEWABLE_TYPES.pdf.includes(ext)) return 'pdf';
  if (PREVIEWABLE_TYPES.image.includes(ext)) return 'image';
  if (PREVIEWABLE_TYPES.text.includes(ext)) return 'text';
  return 'other';
};

export const validateFile = (file) => {
  const ext = file.name.split('.').pop().toLowerCase();
  if (DANGEROUS_EXTENSIONS.includes(ext)) {
    return { valid: false, error: 'Sicherheitsrisiko: Dieser Dateityp ist blockiert.' };
  }
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    return { valid: false, error: `Dateityp nicht unterstützt. Erlaubt sind: ${ALLOWED_EXTENSIONS.join(', ')}` };
  }
  return { valid: true };
};